// Articles hors zone (Aix-en-Provence et alentours uniquement) : gardés publiés,
// retirés du listing public et du sitemap, servis en noindex,follow pour que Google
// les désindexe. Phase 2 (dans 2–3 mois) : redirection 301 vers l'article pilier
// /fr/blog/conciergerie-location-saisonniere-aix-en-provence.
// Garder synchronisé avec scripts/prerender.mjs et supabase/functions/generate-sitemap.
export const SOFT_RETIRED_SLUGS = new Set<string>([
  "conciergerie-saint-tropez-gestion-locative-villas",
  "conciergerie-location-saisonniere-cannes",
  "conciergerie-haut-de-gamme-nice",
  "conciergerie-antibes-juan-les-pins-gestion-locative",
  "conciergerie-frejus-saint-raphael-gestion-locative",
  "conciergerie-marseille-location-saisonniere",
  "conciergerie-avignon-gestion-locative-saisonniere",
  "conciergerie-arles-camargue-gestion-locative",
  "conciergerie-alpilles-saint-remy-provence",
  "conciergerie-luberon",
  "luberon-concierge-service",
]);
